<template>
	<main class="main" ref="mainpart" id="studentMainPage">
		<imChatWin :activeDate="activeDate"></imChatWin>
		<section style="height: 100%">
			<router-view />
		</section>
		<div class="loading-box" style="display: none">
        <van-loading type="spinner" color="white" />
      </div>
	</main>
</template>
<script>
	import imChatWin from './imChatWin.vue'

	export default {
		data() {
			return {
				selected: 'tab2',
				activeDate: new Date().getTime(),
				whitePage: [],
			}
		},

		components: {
			imChatWin
		},
		mounted() {

		},
		methods: {}
	}
</script>
<style lang="scss">
	.main {
		height: 100%;
		position: relative;
	}
</style>


// WEBPACK FOOTER //
// src/components/Main.vue